import { Injectable } from '@angular/core';
import { List } from 'immutable';
import { File } from '../files/file.model';
import { AttachmentView } from './attachment-view.model';
import { Attachment } from './attachment.model';

@Injectable()
export class AttachmentBuilder {
  constructor() {}

  buildAttachment(file: File, title: string = null): Attachment {
    let model: any = {
      [Attachment.KEYS.FILE]: file,
      [Attachment.KEYS.TITLE]: title,
    };

    return new Attachment(model);
  }

  buildAttachmentView(file: File, title: string = null): AttachmentView {
    let model: any = {
      [AttachmentView.KEYS.ATTACHMENT]: {
        [Attachment.KEYS.FILE]: file,
        [Attachment.KEYS.TITLE]: title,
      },
    };

    return new AttachmentView(model);
  }

  buildAttachmentsListFromAttachmentsView(
    attachmentViews: List<AttachmentView>
  ): List<Attachment> {
    return attachmentViews.map(
      (attachmentView) => attachmentView.attachment
    ) as List<Attachment>;
  }
}
